import React from 'react';
import '../App.css'
import { recipes } from "../data/recipe_data.js"

class Recipes extends React.Component {
    

    render() {
        const styles = {
            paragraph: {
                marginTop: 10,
                marginBottom: 0
            }
        }
      return (
        <div className="experience">
          <div className='linkedin_container'>
            <h1>Recipes</h1>
            {recipes.map((value, idk) => (
                <div style={{textAlign:'left', marginLeft:'1em', marginBottom:'1em', marginRight:'1em'}}>
                    <b>{value.display_name}</b>
                    <div className="custom_break"></div>
                    <i>Category: {value.category}</i>
                    <div className="custom_break"></div>
                    <p style={styles.paragraph}>Ingredients:</p>
                    <uo>
                    {value.ingredients.map((item, j) => {
                        return <li>{item}</li>
                    })}
                    </uo>
                    <p style={styles.paragraph}>Instructions:</p>
                    <uo>
                    {value.instructions.map((item, j) => {
                        return <li>{item}</li>
                    })}
                    </uo>
                </div>
            ))}
          </div>
        </div>
      )
    }
}

export default Recipes;